import type { DatabaseQueryStarter } from '../../types/chat';

export interface DatabasePreviewPannelProps {
  projectId: string;
  permissions: string[];
  // The query tab's starter text for the project's database engine
  queryStarter?: DatabaseQueryStarter | null;
  onClose: () => void;
}

export interface ColumnInfo {
  name: string;
  type: string;
}

export interface TableRecordsResponse {
  columns: ColumnInfo[];
  rows: Record<string, any>[];
  total: number;
  page: number;
  page_size: number;
}

export interface QueryResponse {
  columns: string[];
  rows: Record<string, any>[];
  row_count: number;
  affected_rows?: number | null;
  status_message?: string | null;
  // Sent only when the query returned more rows than the query tab shows: rows holds the first row_limit
  row_limit?: number;
}

export enum DatabasePreviewPannelMode {
  BROWSE = 'browse',
  QUERY = 'query',
}